import { inject, injectable } from 'tsyringe';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import { type IInviteCompanyUserRepository } from 'application/repositorySchemas/IInviteCompanyUserRepository';
import { type IInviteCompanyUserClient } from 'interfaceAdapter/gatewaySchemas/IInviteCompanyUserClient';

@injectable()
export class InviteCompanyUserRepository implements IInviteCompanyUserRepository {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('IInviteCompanyUserClient')
        public readonly inviteCompanyUserClient: IInviteCompanyUserClient,
    ) {}

    public async post(email: string) {
        const { data, message } = await this.inviteCompanyUserClient.post({
            token: this.companyUserToken.get() || '',
            email,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
